import React from "react";
import PropTypes from "prop-types";
import Thumb from "../../molecules/Thumb";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import toDataURL from "../../../lib/convert";
import Raven from "raven-js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default class ImageCapture extends React.PureComponent {
  constructor(props) {
    super(props);
    this.clickcount = 0;
    this.state = {
      loading: false,
      image: this.props.image
    };

    // This binding is necessary to make `this` work in the callback
    this.showUploadDialog = this.showUploadDialog.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }
  showUploadDialog(e) {
    this.clickcount++;
    if (this.clickcount === 1) {
      this.uploaddialog.click();
    }
    this.clickcount = 0;
  }

  getImageDimensions(file) {
    return new Promise(function(resolved, rejected) {
      var i = new Image();
      i.onload = function() {
        resolved({ w: i.width, h: i.height });
      };
      i.src = file;
    });
  }

  async handleUpload(e) {
    if (e.currentTarget.files.length < 1) return;
    this.setState({ loading: true });
    const file = e.currentTarget.files[0];
    if (file.size > 4000000) {
      e.currentTarget.value = "";
      this.setState({ loading: false });
      const mb = Math.round(file.size / 1024 / 1024, 2);
      toast.error(
        "Filesize " + mb + "MB is to big! Only images under 4 Mb are supported."
      );
      // Raven.captureMessage(
      //   "Filesize is to big! >5MB",
      //   {extra: {
      //     filesize: file.size
      //   }}
      // );
      return;
    }
    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      e.currentTarget.value = "";
      this.setState({ loading: false });
      toast.error(
        "Filetype not supported! Please provide a JPEG or PNG image."
      );
      //Raven.captureMessage("Filetype not supported JPG/PNG: " + file.type);
      return;
    }

    try {
      const image = await toDataURL(file);
      const dim = await this.getImageDimensions(image);
      if (dim.h < 600 || dim.w < 600) {
        // minmum 200 Dpi required, Size ID Card 85x50mm - 450 x 600 px - info from IM
        this.setState({ loading: false, image: null });
        toast.dismiss();
        toast.error(
          `Image Quality (${dim.w} x ${dim.h} px) too low! Please upload a better image with more than 600px per dimension.`
        );
        this.props.setFieldValue(this.props.variable_name, null);
        // Raven.captureMessage("The resultion for images needs to bigger than 600px for width and height.", {
        //   extra: {
        //     width: dim.w,
        //     height: dim.h,
        //   }
        // });
        return;
      }
      this.setState({
        loading: false,
        image
      });
      this.props.setFieldValue(this.props.variable_name, image);
    } catch (error) {
      window.console && console.error(error);
      Raven.captureException(error);
    }
  }

  render() {
    /*
    spezielle Fixes um im Dialog Upload und Kamera Option anzuzeigen
  */
    //const capture = ( (window.MobileOperatingSystem==='Android' ||(window.MobileOperatingSystem==='iOS' && window.iOSVersion()>=10) )  ?false:true);
    const capture = false;
    const {
      description,
      button_text,
      variable_name,
      image_placeholder,

      error
    } = this.props;
    const id = "file_" + variable_name;
    let box_style;
    if (error) {
      box_style = {
        cursor: "pointer",
        textAlign: "center",
        border: "3px solid red"
      };
    } else {
      box_style = { cursor: "pointer", textAlign: "center" };
    }
    return (
      <div onClick={this.showUploadDialog} style={box_style}>
        <div
          style={{
            height: "220px",
            border: this.state.image !== null ? "1px solid lightgrey" : "",
            padding: "5px",
            marginBottom: "1em"
          }}
        >
          <Thumb
            image={this.state.image}
            loading={this.state.loading}
            placeholder={image_placeholder}
            name={id}
          />
        </div>
        <Typography
          gutterBottom
          style={{
            minHeight: "3em",
            userSelect: "none",
            pointerEvents: "none"
          }}
        >
          {description}
        </Typography>
        <Button
          style={{
            userSelect: "none",
            pointerEvents: "none",
            border: "2px solid lightgrey"
          }}
        >
          {button_text}
        </Button>

        <input
          ref={input => {
            this.uploaddialog = input;
          }}
          id={id}
          name={id}
          type="file"
          onChange={this.handleUpload}
          className="form-control"
          accept="image/*"
          capture={capture}
          style={{ position: "absolute", top: "-1000px", left: "-1000px" }}
        />
        <ToastContainer />
      </div>
    );
  }
}

ImageCapture.propTypes = {
  description: PropTypes.string,
  button_text: PropTypes.string,
  variable_name: PropTypes.string,
  //image_blob: PropTypes.string,
  //image_placeholder: PropTypes.string,
  setFieldValue: PropTypes.func,
  error: PropTypes.string
};
